// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3863":"2d122936ad516211","3877":"fe336940f98fdfab","5673":"8c84e08b49309ac5","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};